import { createStore } from 'vuex';

export default createStore({
  state: {
    customers: [],
    templates: [],
    forms: [],
    formQNums: {},
    transactions: [],
    user: {},
    users: [],
    techs: [],
    shops: [],
    currentShopID: null,
    daysOpen: [],
    comments: [],
    whichShopsSubmittedEOD: [],
    eodReport: {},
    kpiReport: [],
    statReport: [],
    dates: [],
    selectedShop: null,
    techId: null
  },
  mutations: {
    setCustomers(state, customers) {
      state.customers = customers;
    },
    setTemplates(state, templates) {
      state.templates = templates;
    },
    setForms(state, forms) {
      state.forms = forms;
    },
    setFormQNums(state, formQNums) {
      state.formQNums = formQNums;
    },
    setTransactions(state, transactions) {
      state.transactions = transactions;
    },
    setUsers(state, users) {
      state.users = users;
    },
    setUser(state, user) {
      state.user = user;
    },
    setTechnicians(state, techs) {
      state.techs = techs;
    },
    setShops(state, shops) {
      state.shops = shops;
    },
    setCurrentShopID(state, currentShopID) {
        state.currentShopID = currentShopID;
    },
    setDaysOpen(state, daysOpen) {
      state.daysOpen = daysOpen;
    },
    setComments(state, comments) {
      state.comments = comments;
    },
    setWhichStoresSubmittedEOD(state, whichShopsSubmittedEOD) {
      state.whichShopsSubmittedEOD = whichShopsSubmittedEOD;
    },
    setEODReport(state, eodReport) {
      state.eodReport = eodReport;
    },
    setKPIReport(state, kpiReport) {
        state.kpiReport = kpiReport;
    },
    setSTATReport(state, statReport) {
        state.statReport = statReport;
    },
    setDates(state, dates) {
      state.dates = dates;
    },
    setSelectedShop(state, selectedShop) {
      state.selectedShop = selectedShop;
    },
    setTechId(state, techId) {
      state.techId = techId;
    }
  },
  actions: {
    fetchCustomers({ commit }) {
      // Fetch customers from your API here, then commit the 'setCustomers' mutation
    }
  },
  getters: {
    customers: state => state.customers
  }
});